import getPendingOffers from "storefront/GrailedAPI/v1/Users/Offers/getPending";
import { PendingOffer } from "storefront/Offer/PendingOffer";
import { Id } from "storefront/lib/Id";
import useData, { DataResource } from "./data/useData";

type PendingOffers = {
  offersResource: DataResource<Array<PendingOffer>>;
};

const usePendingOffers = (userId: Id): PendingOffers => ({
  offersResource: useData(getPendingOffers, { args: [userId] }),
});

export default usePendingOffers;
